<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_vi"></a>PUBLISHER’S NOTE: This is a work of fiction. Names, characters, places,<br/>and incidents are either the product of the author’s imagination or are used<br/>fictitiously, and any resemblance to actual persons, living or dead, business<br/>establishments, events, or locales is entirely coincidental.</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data<br/>Skovron, Jon.</p>
<p class="copyright">Misfit / by Jon Skovron.<br/>p. cm.</p>
<p class="copyright">Summary: Seattle sixteen-year-old Jael must negotiate normal life in<br/>Catholic school while learning to control the abilities she inherited from her<br/>mother, a demon, and protect those she loves from Belial, the Duke of Hell.</p>
<p class="copyright">ISBN 978-1-4197-0021-7 (alk. paper)</p>
<p class="copyright">[1. Supernatural — Fiction. 2. Demonology — Fiction. 3. Catholic schools — <br/>Fiction. 4. High schools — Fiction. 5. Schools — Fiction. 6. Single-parent<br/>families — Fiction. 7. Seattle (Wash.) — Fiction.] I. Title.<br/>PZ7.S628393Mis 2011<br/>[Fic] — dc22<br/>2010048691</p>
<p class="copyright1">Text copyright © 2011 Jon Skovron<br/>Display type design by Sammy Yuen<br/>Book design by Chad W. Beckerman</p>
<p class="copyright1">The text in this book is set in 11.5-point Cochin.</p>
<p class="copyright1">Published in 2011 by Amulet Books, an imprint of ABRAMS. All<br/>rights reserved. No portion of this book may be reproduced, stored in a<br/>retrieval system, or transmitted in any form or by any means, mechanical,<br/>electronic, photocopying, recording, or otherwise, without written permission<br/>from the publisher. Amulet Books and Amulet Paperbacks<br/>are registered trademarks of Harry N. Abrams, Inc.</p>
<p class="copyright1">Amulet Books are available at special discounts when purchased in quantity<br/>for premiums and promotions as well as fundraising or educational use.<br/>Special editions can also be created to specification. For details, contact<br/>specialsales@abramsbooks.com or the address below.</p>
<p class="image"><img alt="Images" src="images/copyright.jpg"/><br/>115 West 18th Street<br/>New York, NY 10011<br/><a class="nounder" href="http://www.abramsbooks.com" target="_blank">www.abramsbooks.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?382ce2c9